import axios from 'axios';
import { format } from 'date-fns';

const backendUri = process.env.REACT_APP_BACKEND_URI;
// const source_id= localStorage.getItem('analysisStoreId');
// const source_id= "S001"

// const st_id= localStorage.getItem('userData');
// console.log("source_id",source_id)

export const getScanningStats = async (date, storeId,signal) => {
  try {
    const response = await axios.post(
      `${backendUri}/kpi/total_product_scan`,
      {
        Date: format(date, 'yyyy-MM-dd'),
        Source_id:storeId
      },
      { signal }
    );
   
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error fetching scanning stats:', error);
    throw error;
  }
};

export const getExpiryStats = async (date, storeId,signal) => {
  try {
    const response = await axios.post(
      `${backendUri}/kpi/expired`,
      {
        Date: format(date, 'yyyy-MM-dd'),
        Source_id:storeId
      },
      { signal }
    );
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error fetching expiry stats:', error);
    throw error;
  }
};

export const getNearExpiryStats = async (date, storeId,signal) => {
  try {
    const response = await axios.post(
      `${backendUri}/kpi/nearexpired`,
      {
        Date: format(date, 'yyyy-MM-dd'),
        Source_id:storeId
      },
      { signal }
    );
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    // console.error('Error fetching near expiry stats:', error);
    throw error;
  }
};

export const getRevenueImpactStats = async (date, storeId,signal) => {
  try {
    const response = await axios.post(
      `${backendUri}/kpi/revenueCost`,
      {
        date: format(date, 'yyyy-MM-dd'),
        source_id:storeId
      },
      { signal }
    );
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error;
    }
    console.error('Error fetching revenue impact stats:', error);
    throw error;
  }
};

export const fetchTimeRangeData = async (startDate, endDate, storeId, signal) => {
  try {
    const response = await axios.post(`${backendUri}/kpi/graph`, {
      startDate,
      endDate,
      source_id:storeId
    }, { signal });
    return response.data;
  } catch (error) {
    if (error.name === 'CanceledError') {
      console.log('Request cancelled');
    } else {
      console.error('Error fetching time range data:', error);
    }
    throw error;
  }
};

export const fetchThroughputData = async (date, storeId, signal) => {
  try {
    const response = await axios.post(`${backendUri}/kpi/userThroughput`, {
      date: format(date, 'yyyy-MM-dd'),
      store_id:storeId
    },{signal});
    return response.data;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request cancelled');
    } else {
      console.error('Error fetching time range data:', error);
    }
    throw error;
  }
};

export const fetchAndDownloadCSV = async (user_id, date, signal) => {
  try {
    const response = await axios.post(`${backendUri}/kpi/downloadcsv`, {
      userID:user_id,
      date: format(date, 'yyyy-MM-dd')
    },{signal});
    return response;
  } catch (error) {
    if (error.name === 'CanceledError') {
      console.log('Request cancelled');
    } else {
      console.error('Error fetching time range data:', error);
    }
    throw error;
  }
};
